module.exports = __webpack_public_path__ + "static/media/diode.6560201e.glb";